<template>
  <modal :visible.sync="isShowDialog" :title="$t('integration.rule_association')"  width="600px" @close="close">
    <div>
      <div style="height: 50px;line-height:50px;margin-bottom:20px;">
        <span v-if="currSelRule" class="bg-theme color-white pd-10">{{ currSelRule.name }}</span>
        <div style="float:right;">
          <span>{{ $t('integration.rule') }}: </span>
          <el-input v-model="searchName" :placeholder="$t('integration.enter_rule_name')"
           style="width:150px;margin-right:5px;"></el-input>
          <el-button type="primary" icon="el-icon-search" @click="getListFn"></el-button>
        </div>
      </div>
      <!-- 规则list -->
      <div class="rule-list-div">
        <div class="uk-flex mb-10"  v-for="(rule, index) in ruleList"
          :key="rule.id">
          <el-checkbox v-model="rule.checked"
            @change="handleChangeRule(rule)">
          </el-checkbox>
          <div class="uk-flex-1 cursor-pointer" style="margin-left:20px;">{{ rule.name }}</div>
          <div style="width: 30px;">
              <i class="el-icon-tickets cursor-pointer" @click="ruleDetail(rule.id)"></i>
          </div>
        </div>
        <el-divider>{{ $t('public.no_more')}}</el-divider>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="close">{{ $t('public.btn_cancel') }}</el-button>
      <el-button type="primary" @click="handleSave">{{ $t('public.save') }}</el-button>
    </div>

    <!-- 增加无效规则模态框 -->
    <RuleDetailDialog
      v-if="isShowDetailDialog"
      :isShow="isShowDetailDialog"
      :detailInfo="ruleDetailInfo"
      @close="isShowDetailDialog = false">
    </RuleDetailDialog>

  </modal>
</template>
<script>
import { getRuleList, getRuleDetail, ruleSaveCarrier } from '@/api/modules/abnormal.js'
import RuleDetailDialog from './RuleDetailDialog.vue'

export default {
  name: 'ReletedRuleDialog',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    choozeTableData: {
      type: Array,
      default: () => []
    },
  },
  components: {
    RuleDetailDialog
  },
  data(){
    return {
      ruleList: [],
      currSelRule: null, // 当前选择的规则
      searchName: null ,

      ruleDetailInfo: null,
      isShowDetailDialog: false
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
  },
  mounted(){
    this.getListFn()
  },
  methods: {
    close(){
      this.isShowDialog = false
      this.$emit('close')
    },
    getListFn(){
      getRuleList({name: this.searchName}).then(res => {
        if (res.state.code === 200) {
          this.ruleList = res.result
          this.ruleList.forEach(_ => {
            this.$set(_, 'checked', false)
          })
        }
      })

    },
    // 查看规则详情
    ruleDetail(id){
       getRuleDetail(id).then(res => {
        if (res.state.code === 200) {
          this.ruleDetailInfo = res.result
          // 将是group的规则加上name，用于界面显示
          for(let key in this.ruleDetailInfo.rule){
            let nameIndex = 1
            this.ruleDetailInfo.rule[key].forEach(item => {
              if(item.isGroup){
                // item.name = 'Group' + nameIndex
                item.name = 'Group'
                nameIndex ++
              }
            })

          }
          this.isShowDetailDialog = true
        }
      })
    },
    handleChangeRule(item){
      this.ruleList.forEach(_ => {
        this.$set(_, 'checked', false)
      })
      this.$set(item, 'checked', true)
      this.currSelRule = item
      this.$forceUpdate()

    },
    handleSave(){
      let ids = this.choozeTableData.map(_ => _.id)
      ruleSaveCarrier(this.currSelRule.id, ids).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.close()
          this.$parent.getListFns()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.rule-list-div {
  height: 500px;
  overflow-y: auto;
}

</style>
